import React, { useEffect } from "react";
import { Checkbox, SimpleGrid } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { TestLanguage } from "types/testTypes";
import { VIRTUAL_ASSISTANT_LANGUAGE_LIST, LANGUAGE_DATA_MAP } from "@constants/languageConstants";

interface VADownloadLanguageListProps {
  selectedLanguages: TestLanguage[];
  onSelectionChange: (languages: TestLanguage[]) => void;
}

const VADownloadLanguageList: React.FC<VADownloadLanguageListProps> = ({
  selectedLanguages,
  onSelectionChange,
}) => {
  const { t } = useTranslation();

  // English is always selected — ensure it's in the list on mount
  useEffect(() => {
    if (!selectedLanguages.includes(TestLanguage.English)) {
      onSelectionChange([TestLanguage.English, ...selectedLanguages]);
    }
  }, []);

  const handleToggle = (lang: TestLanguage, checked: boolean) => {
    if (lang === TestLanguage.English) return; // locked
    if (checked) {
      onSelectionChange([...selectedLanguages, lang]);
    } else {
      onSelectionChange(selectedLanguages.filter((l) => l !== lang));
    }
  };

  return (
    <SimpleGrid cols={{ base: 1, xs: 2, sm: 3 }} spacing="xs">
      {VIRTUAL_ASSISTANT_LANGUAGE_LIST.filter(
        ({ value }) => value !== TestLanguage.NOT_SPECIFIED,
      ).map(({ value }) => {
        const isEnglish = value === TestLanguage.English;
        return (
          <Checkbox
            key={value}
            label={t(LANGUAGE_DATA_MAP[value].translationKey)}
            checked={isEnglish || selectedLanguages.includes(value)}
            onChange={(e) => handleToggle(value, e.currentTarget.checked)}
            disabled={isEnglish}
            styles={
              isEnglish
                ? {
                    input: { cursor: "not-allowed", opacity: 0.7 },
                    label: { cursor: "not-allowed", opacity: 0.7 },
                  }
                : undefined
            }
          />
        );
      })}
    </SimpleGrid>
  );
};

export default VADownloadLanguageList;
